import { BaseRestDataProvider } from './BaseRestDataProvider';
import { Supplier } from '../models/Supplier';

export class SupplierRestDataProvider extends BaseRestDataProvider {
  constructor() {
    super('/v1/suppliers');
  }

  getAll(): Promise<Supplier[]> {
    return this.get<Supplier[]>(``);
  }

  getById(id: string): Promise<Supplier> {
    return this.get<Supplier>(`/${id}`);
  }

  add(supplier: Supplier): Promise<Supplier> {
    return this.post<Supplier>(``, supplier);
  }

  update(id: string, supplier: Supplier): Promise<void> {
    return this.put<void>(`/${id}`, supplier);
  }

  delete(id: string): Promise<void> {
    return super.delete(`/${id}`);
  }
}

export type { Supplier };
